import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModuleLabelKey, TranslationKeyWithCssClass } from '@ca/core/models';

@Component({
    selector: 'ca-module-badge',
    templateUrl: './module-badge.component.html',
    styleUrls: ['../badge.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModuleBadgeComponent {
    @Input() labelKey: ModuleLabelKey;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    MODULE_BADGE_LABELS_MAP: { [key in ModuleLabelKey]: TranslationKeyWithCssClass } = {
        improvementsNeeded: { translationKey: 'MODULES.BADGE_LABEL.IMPROVEMENTS_NEEDED', cssClass: 'type-improvements-needed' },
        public: { translationKey: 'MODULES.BADGE_LABEL.PUBLIC', cssClass: 'type-public' },
        shared: { translationKey: 'MODULES.BADGE_LABEL.SHARED', cssClass: 'type-shared' },
        submitted: { translationKey: 'MODULES.BADGE_LABEL.SUBMITTED', cssClass: 'type-submitted' },
        unpublished: { translationKey: 'MODULES.BADGE_LABEL.UNPUBLISHED', cssClass: 'type-unpublished' },
    };
}
